module.exports = "/_next/static/images/bg-86500cc299d5f3c1271451d7435c7fe3.png";